<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Select a Billing Customer') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12">
          <div class="form-group">
            <label for="billingCustomer">{{ _('Billing Customer') }}</label><br />
            <v-select :options="billingcustomers" v-model="billingcustomer" label="company" keys="['id', 'company']" :placeholder="_('Type to search billing customers')" :create-item="false">
              <template v-slot:no-options="{ searching }">
                <template v-if="searching">
                  {{ _('No results found.') }}
                </template>
                <template v-else>{{ _('Type to search billing customers') }}</template>
              </template>
            </v-select>
          </div>
        </div>
      </div>
      <div style="height: 300px"></div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="selectBillingcustomer"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import constants from '~/lib/constants'

export default {
  props: ['selectedBillingcustomers'],
  mixins: [constants],
  data () {
    return {
      billingcustomer: null,
      billingcustomers: []
    }
  },
  computed: {
    ...mapGetters(['shopId', 'baseDomain', 'apiKey']),
    selectedBillingcustomerIds () {
      return this.selectedBillingcustomers.map(c => c.id)
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    selectBillingcustomer () {
      this.$emit('selectBillingcustomer', this.billingcustomer)
    },
    async loadBillingcustomers() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/billingcustomers.json?iSortingCols=1&iSortCol_0=1&sSortDir_0=asc&apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      this.billingcustomers = response.data.filter(billingcustomer => {
        return this.selectedBillingcustomerIds.indexOf(billingcustomer.id) === -1 // Only list billing customers that are not already added
      })
    }
  },
  mounted () {
    this.loadBillingcustomers()
  }
}
</script>